var _excluded = ["children", "inputRef", "isDisabled", "isReadOnly", "isViewMode", "isLoading", "columns", "error", "as"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { createContext, useContext } from 'react';
import { Loader } from '../../../foundations/Loader';
import { forwardRef } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { SectionBanner } from '../../dataDisplay';
import { Box } from '../Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FormContext = /*#__PURE__*/createContext({
  columns: 1
});
export var useFormContext = () => useContext(FormContext);
/**
 * @private Please use `Form` from `@melio/penny`.
 */

export var _Form = forwardRef((_ref, ref) => {
  var {
    children,
    inputRef,
    isDisabled,
    isReadOnly,
    isViewMode,
    isLoading,
    columns = 1,
    error,
    as
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var style = useMultiStyleConfig('Form', _objectSpread({}, props));
  return /*#__PURE__*/_jsx(Box, {
    __css: style['formContainer'],
    children: /*#__PURE__*/_jsxs(FormContext.Provider, {
      value: {
        size: props.size,
        columns,
        isDisabled,
        isReadOnly,
        isViewMode,
        isLoading
      },
      children: [error ? /*#__PURE__*/_jsx(SectionBanner, {
        title: error.title,
        description: error.description,
        variant: "critical",
        "data-testid": "form-general-error"
      }) : null, /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
        "data-component": "_Form",
        gridTemplateColumns: {
          xs: 'none',
          s: "repeat(".concat(columns, ", minmax(0, 1fr))")
        }
      }, props), {}, {
        // switch the top element to force re-render when toggling view/edit mode
        // this helps with autoFocus when moving from view mode to edit mode
        as: as !== null && as !== void 0 ? as : isViewMode ? 'article' : 'form',
        display: "grid",
        "data-readonly": isReadOnly,
        "data-view-mode": isViewMode,
        __css: style['form'],
        "aria-disabled": isDisabled,
        ref: ref // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ,
        noValidate: true,
        children: [children, /*#__PURE__*/_jsx("input", {
          ref: inputRef,
          type: "submit",
          hidden: true
        }), isLoading && /*#__PURE__*/_jsx(Box, {
          __css: style['loader'],
          children: /*#__PURE__*/_jsx(Loader, {
            "data-testid": "form-loader"
          })
        })]
      }))]
    })
  });
});
_Form.displayName = '_Form';
//# sourceMappingURL=_Form.js.map